// useAuthListeners.js
// Purpose: Encapsulates window/document event listeners for auth/session management (tab visibility, beforeunload, etc).
// Main functions: Sets up and cleans up listeners for beforeunload and visibilitychange events. Calls provided handlers.
// Inputs: handleBeforeUnload (fn), handleVisibilityChange (fn)

import { useEffect } from 'react';

/**
 * useAuthListeners - Hook to manage auth-related event listeners
 * @param {(e: BeforeUnloadEvent) => any} handleBeforeUnload - Called on window beforeunload
 * @param {(e: Event) => any} handleVisibilityChange - Called on document visibilitychange
 */
export default function useAuthListeners(handleBeforeUnload, handleVisibilityChange) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    // Cast to EventListener to satisfy TS signatures
    window.addEventListener('beforeunload', /** @type {any} */ (handleBeforeUnload));
    document.addEventListener('visibilitychange', /** @type {any} */ (handleVisibilityChange));
    return () => {
      window.removeEventListener('beforeunload', /** @type {any} */ (handleBeforeUnload));
      document.removeEventListener('visibilitychange', /** @type {any} */ (handleVisibilityChange));
    };
  }, [handleBeforeUnload, handleVisibilityChange]);
}
